import { render, staticRenderFns } from "./DeleteAdvert.vue?vue&type=template&id=4ef7021e&scoped=true"
import script from "./DeleteAdvert.vue?vue&type=script&lang=js"
export * from "./DeleteAdvert.vue?vue&type=script&lang=js"
import style0 from "./DeleteAdvert.vue?vue&type=style&index=0&id=4ef7021e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7021e",
  null
  
)

export default component.exports